module.exports = __webpack_public_path__ + "static/media/empathy.e4275518.svg";